import { render, staticRenderFns } from "./register-dialog.vue?vue&type=template&id=df485028&scoped=true&"
import script from "./register-dialog.vue?vue&type=script&lang=js&"
export * from "./register-dialog.vue?vue&type=script&lang=js&"
import style0 from "./register-dialog.vue?vue&type=style&index=0&id=df485028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df485028",
  null
  
)

export default component.exports